import { ALL_MENU_OBJECT_DATA, mapData, siteData } from 'routers/routes.data';

import {
  getConsoleMenu,
  getServiceGroups,
  parseSectionApis,
} from 'utils/menu/gnbUtil';
import { getMenuByProperty, getPageByKey } from 'utils/menu/routePageUtil';

/**
 * site.json의 service_groups를 파싱합니다.
 * siteData.service_groups가 존재해야 합니다.
 * "API 및 SDK" 그룹에서 "검색", "경로" 섹션을 찾아 Exports를 생성합니다.
 */
// 1. service_groups 가져오기
const serviceGroups = siteData.service_groups || {};

// 2. API SDK 그룹 찾기
const apiSdkGroup = serviceGroups['service_api_sdk'];
const apiSdkSections = apiSdkGroup ? apiSdkGroup.sections : [];

// 3. 각 섹션 ("지도", "검색", "경로") 찾기
const searchSection = apiSdkSections.find((s) => s.title === '검색');
const routeSection = apiSdkSections.find((s) => s.title === '경로');

// 4. Export 될 Constant 생성 (FEATURE_GUIDE_MAPPER_CONST 등에서 사용)
export const menuBarV2SubMapContentConst = parseSectionApis({
  apis: mapData.api_map_guide,
});

export const menuBarV2SubSearchContentConst = parseSectionApis(searchSection);
export const menuBarV2SubRouteContentConst = parseSectionApis(routeSection);

// 5. 페이지 이동
const landingPage = getPageByKey('landing');

/**
 * 전체 메뉴 구성을 정의합니다.
 */
export const menuBarV2ContentConst = {
  소개: [
    {
      sections: getMenuByProperty(siteData, '소개'),
    },
  ],
  요금제: [
    {
      sections: [
        getPageByKey('billing_plan'),
        {
          title: '서비스별 요금',
          description:
            '체험형 상품부터 후불형 상품까지, 상품 정보를 더 자세히 확인해보세요.',
          path: '/billing-plan-info-free',
          content: getMenuByProperty(
            ALL_MENU_OBJECT_DATA.billing,
            'billing_plan_info'
          ),
        },
        getPageByKey('billing_plan_calc'),
      ],
    },
  ],
  서비스: [
    {
      depth: true,
      groups: getServiceGroups(serviceGroups),
    },
  ],
  솔루션: [
    {
      sections: getMenuByProperty(siteData, '솔루션'),
    },
  ],
  소식: [
    {
      sections: getMenuByProperty(siteData, '소식'),
    },
  ],
  문의하기: [
    {
      sections: getMenuByProperty(siteData, '문의하기'),
    },
  ],
};

/**
 * 대시보드(Console) 메뉴 구성을 정의합니다.
 * site.json의 CONSOLE 메뉴를 기반으로 생성됩니다.
 */
export const dashBoardV2ContentConst = {
  CONSOLE: getConsoleMenu(),
};
